//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * Retrieves a page of type Form from forms.
     * @param itemId The identifier of the item to retrieve (alias, path or ID).
     * @param language The language
     * @return Success
     */
    contentFormsForm(itemId: string, language: string): Promise<FormsSpecificForm>;
    /**
     * Retrieves a page of type Generic form from forms.
     * @param itemId The identifier of the item to retrieve (alias, path or ID).
     * @param language The language
     * @return Success
     */
    contentFormsGenericForm(itemId: string, language: string): Promise<FormsGenericForm>;
}

export class Client implements IClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieves a page of type Form from forms.
     * @param itemId The identifier of the item to retrieve (alias, path or ID).
     * @param language The language
     * @return Success
     */
    contentFormsForm(itemId: string, language: string, cancelToken?: CancelToken): Promise<FormsSpecificForm> {
        let url_ = this.baseUrl + "/content/forms/{language}/{itemId}/form";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContentFormsForm(_response);
        });
    }

    protected processContentFormsForm(response: AxiosResponse): Promise<FormsSpecificForm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsSpecificForm.fromJS(resultData200);
            return Promise.resolve<FormsSpecificForm>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsSpecificForm>(null as any);
    }

    /**
     * Retrieves a page of type Generic form from forms.
     * @param itemId The identifier of the item to retrieve (alias, path or ID).
     * @param language The language
     * @return Success
     */
    contentFormsGenericForm(itemId: string, language: string, cancelToken?: CancelToken): Promise<FormsGenericForm> {
        let url_ = this.baseUrl + "/content/forms/{language}/{itemId}/generic-form";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContentFormsGenericForm(_response);
        });
    }

    protected processContentFormsGenericForm(response: AxiosResponse): Promise<FormsGenericForm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FormsGenericForm.fromJS(resultData200);
            return Promise.resolve<FormsGenericForm>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormsGenericForm>(null as any);
    }
}

export class ContentReference implements IContentReference {
    label!: string;
    link!: string;
    id!: number;
    site!: string;
    pagetype?: string | null;
    alias?: string | null;

    constructor(data?: IContentReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.pagetype = _data["pagetype"] !== undefined ? _data["pagetype"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
        }
    }

    static fromJS(data: any): ContentReference {
        data = typeof data === 'object' ? data : {};
        let result = new ContentReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["link"] = this.link !== undefined ? this.link : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["pagetype"] = this.pagetype !== undefined ? this.pagetype : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        return data;
    }
}

export interface IContentReference {
    label: string;
    link: string;
    id: number;
    site: string;
    pagetype?: string | null;
    alias?: string | null;
}

/** Form */
export class FormsSpecificForm implements IFormsSpecificForm {
    label!: string;
    link!: string;
    id!: number;
    site!: string;
    pagetype?: string | null;
    alias?: string | null;
    order!: number;
    slug!: string;
    created!: Date;
    issued!: Date;
    modified?: Date | null;
    validUntil?: Date | null;
    availableFrom!: Date;
    availableUntil?: Date | null;
    ancestors!: ContentReference[];
    see?: ContentReference;
    title!: string;
    formContent!: FormsSpecificFormFormContent;
    formSections!: FormsSpecificFormFormSections;
    formFields!: FormsSpecificFormFormFields;
    formFieldOptions!: FormsSpecificFormFormFieldOptions;

    constructor(data?: IFormsSpecificForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.ancestors) {
                this.ancestors = [];
                for (let i = 0; i < data.ancestors.length; i++) {
                    let item = data.ancestors[i];
                    this.ancestors[i] = item && !(<any>item).toJSON ? new ContentReference(item) : <ContentReference>item;
                }
            }
            this.see = data.see && !(<any>data.see).toJSON ? new ContentReference(data.see) : <ContentReference>this.see;
            this.formContent = data.formContent && !(<any>data.formContent).toJSON ? new FormsSpecificFormFormContent(data.formContent) : <FormsSpecificFormFormContent>this.formContent;
            this.formSections = data.formSections && !(<any>data.formSections).toJSON ? new FormsSpecificFormFormSections(data.formSections) : <FormsSpecificFormFormSections>this.formSections;
            this.formFields = data.formFields && !(<any>data.formFields).toJSON ? new FormsSpecificFormFormFields(data.formFields) : <FormsSpecificFormFormFields>this.formFields;
            this.formFieldOptions = data.formFieldOptions && !(<any>data.formFieldOptions).toJSON ? new FormsSpecificFormFormFieldOptions(data.formFieldOptions) : <FormsSpecificFormFormFieldOptions>this.formFieldOptions;
        }
        if (!data) {
            this.ancestors = [];
            this.formContent = new FormsSpecificFormFormContent();
            this.formSections = new FormsSpecificFormFormSections();
            this.formFields = new FormsSpecificFormFormFields();
            this.formFieldOptions = new FormsSpecificFormFormFieldOptions();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.pagetype = _data["pagetype"] !== undefined ? _data["pagetype"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : <any>null;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>null;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.availableFrom = _data["availableFrom"] ? new Date(_data["availableFrom"].toString()) : <any>null;
            this.availableUntil = _data["availableUntil"] ? new Date(_data["availableUntil"].toString()) : <any>null;
            if (Array.isArray(_data["ancestors"])) {
                this.ancestors = [] as any;
                for (let item of _data["ancestors"])
                    this.ancestors!.push(ContentReference.fromJS(item));
            }
            else {
                this.ancestors = <any>null;
            }
            this.see = _data["see"] ? ContentReference.fromJS(_data["see"]) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.formContent = _data["formContent"] ? FormsSpecificFormFormContent.fromJS(_data["formContent"]) : new FormsSpecificFormFormContent();
            this.formSections = _data["formSections"] ? FormsSpecificFormFormSections.fromJS(_data["formSections"]) : new FormsSpecificFormFormSections();
            this.formFields = _data["formFields"] ? FormsSpecificFormFormFields.fromJS(_data["formFields"]) : new FormsSpecificFormFormFields();
            this.formFieldOptions = _data["formFieldOptions"] ? FormsSpecificFormFormFieldOptions.fromJS(_data["formFieldOptions"]) : new FormsSpecificFormFormFieldOptions();
        }
    }

    static fromJS(data: any): FormsSpecificForm {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["link"] = this.link !== undefined ? this.link : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["pagetype"] = this.pagetype !== undefined ? this.pagetype : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["slug"] = this.slug !== undefined ? this.slug : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>null;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : <any>null;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : <any>null;
        data["availableUntil"] = this.availableUntil ? formatDate(this.availableUntil) : <any>null;
        if (Array.isArray(this.ancestors)) {
            data["ancestors"] = [];
            for (let item of this.ancestors)
                data["ancestors"].push(item.toJSON());
        }
        data["see"] = this.see ? this.see.toJSON() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["formContent"] = this.formContent ? this.formContent.toJSON() : <any>null;
        data["formSections"] = this.formSections ? this.formSections.toJSON() : <any>null;
        data["formFields"] = this.formFields ? this.formFields.toJSON() : <any>null;
        data["formFieldOptions"] = this.formFieldOptions ? this.formFieldOptions.toJSON() : <any>null;
        return data;
    }
}

/** Form */
export interface IFormsSpecificForm {
    label: string;
    link: string;
    id: number;
    site: string;
    pagetype?: string | null;
    alias?: string | null;
    order: number;
    slug: string;
    created: Date;
    issued: Date;
    modified?: Date | null;
    validUntil?: Date | null;
    availableFrom: Date;
    availableUntil?: Date | null;
    ancestors: IContentReference[];
    see?: IContentReference;
    title: string;
    formContent: IFormsSpecificFormFormContent;
    formSections: IFormsSpecificFormFormSections;
    formFields: IFormsSpecificFormFormFields;
    formFieldOptions: IFormsSpecificFormFormFieldOptions;
}

/** formContent */
export class FormsSpecificFormFormContent implements IFormsSpecificFormFormContent {
    formLanguage!: FormLanguage;
    /** De introductie tekst die in de eerste stap van het formulier wordt getoond. */
    formIntroduction?: string | null;
    /** De tekst die wordt getoond nadat het formulier verstuurd is. */
    formThankYou?: string | null;

    constructor(data?: IFormsSpecificFormFormContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formLanguage = _data["formLanguage"] !== undefined ? _data["formLanguage"] : <any>null;
            this.formIntroduction = _data["formIntroduction"] !== undefined ? _data["formIntroduction"] : <any>null;
            this.formThankYou = _data["formThankYou"] !== undefined ? _data["formThankYou"] : <any>null;
        }
    }

    static fromJS(data: any): FormsSpecificFormFormContent {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formLanguage"] = this.formLanguage !== undefined ? this.formLanguage : <any>null;
        data["formIntroduction"] = this.formIntroduction !== undefined ? this.formIntroduction : <any>null;
        data["formThankYou"] = this.formThankYou !== undefined ? this.formThankYou : <any>null;
        return data;
    }
}

/** formContent */
export interface IFormsSpecificFormFormContent {
    formLanguage: FormLanguage;
    /** De introductie tekst die in de eerste stap van het formulier wordt getoond. */
    formIntroduction?: string | null;
    /** De tekst die wordt getoond nadat het formulier verstuurd is. */
    formThankYou?: string | null;
}

/** formFieldOptions */
export class FormsSpecificFormFormFieldOptions implements IFormsSpecificFormFormFieldOptions {
    /** formFieldOptions */
    formFieldOptions!: FormsSpecificFormFormFieldOptionsFormFieldOptions[];

    constructor(data?: IFormsSpecificFormFormFieldOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.formFieldOptions) {
                this.formFieldOptions = [];
                for (let i = 0; i < data.formFieldOptions.length; i++) {
                    let item = data.formFieldOptions[i];
                    this.formFieldOptions[i] = item && !(<any>item).toJSON ? new FormsSpecificFormFormFieldOptionsFormFieldOptions(item) : <FormsSpecificFormFormFieldOptionsFormFieldOptions>item;
                }
            }
        }
        if (!data) {
            this.formFieldOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formFieldOptions"])) {
                this.formFieldOptions = [] as any;
                for (let item of _data["formFieldOptions"])
                    this.formFieldOptions!.push(FormsSpecificFormFormFieldOptionsFormFieldOptions.fromJS(item));
            }
            else {
                this.formFieldOptions = <any>null;
            }
        }
    }

    static fromJS(data: any): FormsSpecificFormFormFieldOptions {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormFieldOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formFieldOptions)) {
            data["formFieldOptions"] = [];
            for (let item of this.formFieldOptions)
                data["formFieldOptions"].push(item.toJSON());
        }
        return data;
    }
}

/** formFieldOptions */
export interface IFormsSpecificFormFormFieldOptions {
    /** formFieldOptions */
    formFieldOptions: IFormsSpecificFormFormFieldOptionsFormFieldOptions[];
}

/** formFieldOptions */
export class FormsSpecificFormFormFieldOptionsFormFieldOptions implements IFormsSpecificFormFormFieldOptionsFormFieldOptions {
    /** inputIdentifier */
    inputIdentifier!: string;
    /** dropdownOptionValue */
    dropdownOptionValue!: string;
    /** dropdownOptionLabel */
    dropdownOptionLabel?: string | null;
    /** dropdownOptionText */
    dropdownOptionText?: string | null;

    constructor(data?: IFormsSpecificFormFormFieldOptionsFormFieldOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputIdentifier = _data["inputIdentifier"] !== undefined ? _data["inputIdentifier"] : <any>null;
            this.dropdownOptionValue = _data["dropdownOptionValue"] !== undefined ? _data["dropdownOptionValue"] : <any>null;
            this.dropdownOptionLabel = _data["dropdownOptionLabel"] !== undefined ? _data["dropdownOptionLabel"] : <any>null;
            this.dropdownOptionText = _data["dropdownOptionText"] !== undefined ? _data["dropdownOptionText"] : <any>null;
        }
    }

    static fromJS(data: any): FormsSpecificFormFormFieldOptionsFormFieldOptions {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormFieldOptionsFormFieldOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputIdentifier"] = this.inputIdentifier !== undefined ? this.inputIdentifier : <any>null;
        data["dropdownOptionValue"] = this.dropdownOptionValue !== undefined ? this.dropdownOptionValue : <any>null;
        data["dropdownOptionLabel"] = this.dropdownOptionLabel !== undefined ? this.dropdownOptionLabel : <any>null;
        data["dropdownOptionText"] = this.dropdownOptionText !== undefined ? this.dropdownOptionText : <any>null;
        return data;
    }
}

/** formFieldOptions */
export interface IFormsSpecificFormFormFieldOptionsFormFieldOptions {
    /** inputIdentifier */
    inputIdentifier: string;
    /** dropdownOptionValue */
    dropdownOptionValue: string;
    /** dropdownOptionLabel */
    dropdownOptionLabel?: string | null;
    /** dropdownOptionText */
    dropdownOptionText?: string | null;
}

/** formFields */
export class FormsSpecificFormFormFields implements IFormsSpecificFormFormFields {
    /** formFieldContent */
    formFieldContent!: FormsSpecificFormFormFieldsFormFieldContent[];

    constructor(data?: IFormsSpecificFormFormFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.formFieldContent) {
                this.formFieldContent = [];
                for (let i = 0; i < data.formFieldContent.length; i++) {
                    let item = data.formFieldContent[i];
                    this.formFieldContent[i] = item && !(<any>item).toJSON ? new FormsSpecificFormFormFieldsFormFieldContent(item) : <FormsSpecificFormFormFieldsFormFieldContent>item;
                }
            }
        }
        if (!data) {
            this.formFieldContent = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formFieldContent"])) {
                this.formFieldContent = [] as any;
                for (let item of _data["formFieldContent"])
                    this.formFieldContent!.push(FormsSpecificFormFormFieldsFormFieldContent.fromJS(item));
            }
            else {
                this.formFieldContent = <any>null;
            }
        }
    }

    static fromJS(data: any): FormsSpecificFormFormFields {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formFieldContent)) {
            data["formFieldContent"] = [];
            for (let item of this.formFieldContent)
                data["formFieldContent"].push(item.toJSON());
        }
        return data;
    }
}

/** formFields */
export interface IFormsSpecificFormFormFields {
    /** formFieldContent */
    formFieldContent: IFormsSpecificFormFormFieldsFormFieldContent[];
}

/** formFieldContent */
export class FormsSpecificFormFormFieldsFormFieldContent implements IFormsSpecificFormFormFieldsFormFieldContent {
    /** inputIdentifier */
    inputIdentifier!: string;
    /** internalComment */
    internalComment?: string | null;
    /** Specifiek: vul altijd in. Generiek: vul alleen in al je wilt afwijken van de generieke veldnaam. */
    inputLabel?: string | null;
    /** inputAdditionalInformation */
    inputAdditionalInformation?: string | null;

    constructor(data?: IFormsSpecificFormFormFieldsFormFieldContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputIdentifier = _data["inputIdentifier"] !== undefined ? _data["inputIdentifier"] : <any>null;
            this.internalComment = _data["internalComment"] !== undefined ? _data["internalComment"] : <any>null;
            this.inputLabel = _data["inputLabel"] !== undefined ? _data["inputLabel"] : <any>null;
            this.inputAdditionalInformation = _data["inputAdditionalInformation"] !== undefined ? _data["inputAdditionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): FormsSpecificFormFormFieldsFormFieldContent {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormFieldsFormFieldContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputIdentifier"] = this.inputIdentifier !== undefined ? this.inputIdentifier : <any>null;
        data["internalComment"] = this.internalComment !== undefined ? this.internalComment : <any>null;
        data["inputLabel"] = this.inputLabel !== undefined ? this.inputLabel : <any>null;
        data["inputAdditionalInformation"] = this.inputAdditionalInformation !== undefined ? this.inputAdditionalInformation : <any>null;
        return data;
    }
}

/** formFieldContent */
export interface IFormsSpecificFormFormFieldsFormFieldContent {
    /** inputIdentifier */
    inputIdentifier: string;
    /** internalComment */
    internalComment?: string | null;
    /** Specifiek: vul altijd in. Generiek: vul alleen in al je wilt afwijken van de generieke veldnaam. */
    inputLabel?: string | null;
    /** inputAdditionalInformation */
    inputAdditionalInformation?: string | null;
}

/** formSections */
export class FormsSpecificFormFormSections implements IFormsSpecificFormFormSections {
    /** formSection */
    formSection!: FormsSpecificFormFormSectionsFormSection[];

    constructor(data?: IFormsSpecificFormFormSections) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.formSection) {
                this.formSection = [];
                for (let i = 0; i < data.formSection.length; i++) {
                    let item = data.formSection[i];
                    this.formSection[i] = item && !(<any>item).toJSON ? new FormsSpecificFormFormSectionsFormSection(item) : <FormsSpecificFormFormSectionsFormSection>item;
                }
            }
        }
        if (!data) {
            this.formSection = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formSection"])) {
                this.formSection = [] as any;
                for (let item of _data["formSection"])
                    this.formSection!.push(FormsSpecificFormFormSectionsFormSection.fromJS(item));
            }
            else {
                this.formSection = <any>null;
            }
        }
    }

    static fromJS(data: any): FormsSpecificFormFormSections {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormSections();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formSection)) {
            data["formSection"] = [];
            for (let item of this.formSection)
                data["formSection"].push(item.toJSON());
        }
        return data;
    }
}

/** formSections */
export interface IFormsSpecificFormFormSections {
    /** formSection */
    formSection: IFormsSpecificFormFormSectionsFormSection[];
}

/** formSection */
export class FormsSpecificFormFormSectionsFormSection implements IFormsSpecificFormFormSectionsFormSection {
    /** sectionIdentifier */
    sectionIdentifier!: string;
    /** De titel van een sectie */
    sectionTitle!: string;
    /** Optionele introductie van een sectie */
    sectionText?: string | null;

    constructor(data?: IFormsSpecificFormFormSectionsFormSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionIdentifier = _data["sectionIdentifier"] !== undefined ? _data["sectionIdentifier"] : <any>null;
            this.sectionTitle = _data["sectionTitle"] !== undefined ? _data["sectionTitle"] : <any>null;
            this.sectionText = _data["sectionText"] !== undefined ? _data["sectionText"] : <any>null;
        }
    }

    static fromJS(data: any): FormsSpecificFormFormSectionsFormSection {
        data = typeof data === 'object' ? data : {};
        let result = new FormsSpecificFormFormSectionsFormSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionIdentifier"] = this.sectionIdentifier !== undefined ? this.sectionIdentifier : <any>null;
        data["sectionTitle"] = this.sectionTitle !== undefined ? this.sectionTitle : <any>null;
        data["sectionText"] = this.sectionText !== undefined ? this.sectionText : <any>null;
        return data;
    }
}

/** formSection */
export interface IFormsSpecificFormFormSectionsFormSection {
    /** sectionIdentifier */
    sectionIdentifier: string;
    /** De titel van een sectie */
    sectionTitle: string;
    /** Optionele introductie van een sectie */
    sectionText?: string | null;
}

/** Generic form */
export class FormsGenericForm implements IFormsGenericForm {
    label!: string;
    link!: string;
    id!: number;
    site!: string;
    pagetype?: string | null;
    alias?: string | null;
    order!: number;
    slug!: string;
    created!: Date;
    issued!: Date;
    modified?: Date | null;
    validUntil?: Date | null;
    availableFrom!: Date;
    availableUntil?: Date | null;
    ancestors!: ContentReference[];
    see?: ContentReference;
    title!: string;
    formContent!: FormsGenericFormFormContent;
    formFields!: FormsGenericFormFormFields;

    constructor(data?: IFormsGenericForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.ancestors) {
                this.ancestors = [];
                for (let i = 0; i < data.ancestors.length; i++) {
                    let item = data.ancestors[i];
                    this.ancestors[i] = item && !(<any>item).toJSON ? new ContentReference(item) : <ContentReference>item;
                }
            }
            this.see = data.see && !(<any>data.see).toJSON ? new ContentReference(data.see) : <ContentReference>this.see;
            this.formContent = data.formContent && !(<any>data.formContent).toJSON ? new FormsGenericFormFormContent(data.formContent) : <FormsGenericFormFormContent>this.formContent;
            this.formFields = data.formFields && !(<any>data.formFields).toJSON ? new FormsGenericFormFormFields(data.formFields) : <FormsGenericFormFormFields>this.formFields;
        }
        if (!data) {
            this.ancestors = [];
            this.formContent = new FormsGenericFormFormContent();
            this.formFields = new FormsGenericFormFormFields();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.pagetype = _data["pagetype"] !== undefined ? _data["pagetype"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : <any>null;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>null;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.availableFrom = _data["availableFrom"] ? new Date(_data["availableFrom"].toString()) : <any>null;
            this.availableUntil = _data["availableUntil"] ? new Date(_data["availableUntil"].toString()) : <any>null;
            if (Array.isArray(_data["ancestors"])) {
                this.ancestors = [] as any;
                for (let item of _data["ancestors"])
                    this.ancestors!.push(ContentReference.fromJS(item));
            }
            else {
                this.ancestors = <any>null;
            }
            this.see = _data["see"] ? ContentReference.fromJS(_data["see"]) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.formContent = _data["formContent"] ? FormsGenericFormFormContent.fromJS(_data["formContent"]) : new FormsGenericFormFormContent();
            this.formFields = _data["formFields"] ? FormsGenericFormFormFields.fromJS(_data["formFields"]) : new FormsGenericFormFormFields();
        }
    }

    static fromJS(data: any): FormsGenericForm {
        data = typeof data === 'object' ? data : {};
        let result = new FormsGenericForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["link"] = this.link !== undefined ? this.link : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["pagetype"] = this.pagetype !== undefined ? this.pagetype : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["slug"] = this.slug !== undefined ? this.slug : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>null;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : <any>null;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : <any>null;
        data["availableUntil"] = this.availableUntil ? formatDate(this.availableUntil) : <any>null;
        if (Array.isArray(this.ancestors)) {
            data["ancestors"] = [];
            for (let item of this.ancestors)
                data["ancestors"].push(item.toJSON());
        }
        data["see"] = this.see ? this.see.toJSON() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["formContent"] = this.formContent ? this.formContent.toJSON() : <any>null;
        data["formFields"] = this.formFields ? this.formFields.toJSON() : <any>null;
        return data;
    }
}

/** Generic form */
export interface IFormsGenericForm {
    label: string;
    link: string;
    id: number;
    site: string;
    pagetype?: string | null;
    alias?: string | null;
    order: number;
    slug: string;
    created: Date;
    issued: Date;
    modified?: Date | null;
    validUntil?: Date | null;
    availableFrom: Date;
    availableUntil?: Date | null;
    ancestors: IContentReference[];
    see?: IContentReference;
    title: string;
    formContent: IFormsGenericFormFormContent;
    formFields: IFormsGenericFormFormFields;
}

/** formContent */
export class FormsGenericFormFormContent implements IFormsGenericFormFormContent {
    formLanguage!: FormLanguage;
    /** De tekst onder elk formulier */
    formOutro?: string | null;
    /** De tekst welke wordt weergegeven bij de PDF download */
    formDownloadInformation?: string | null;

    constructor(data?: IFormsGenericFormFormContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formLanguage = _data["formLanguage"] !== undefined ? _data["formLanguage"] : <any>null;
            this.formOutro = _data["formOutro"] !== undefined ? _data["formOutro"] : <any>null;
            this.formDownloadInformation = _data["formDownloadInformation"] !== undefined ? _data["formDownloadInformation"] : <any>null;
        }
    }

    static fromJS(data: any): FormsGenericFormFormContent {
        data = typeof data === 'object' ? data : {};
        let result = new FormsGenericFormFormContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formLanguage"] = this.formLanguage !== undefined ? this.formLanguage : <any>null;
        data["formOutro"] = this.formOutro !== undefined ? this.formOutro : <any>null;
        data["formDownloadInformation"] = this.formDownloadInformation !== undefined ? this.formDownloadInformation : <any>null;
        return data;
    }
}

/** formContent */
export interface IFormsGenericFormFormContent {
    formLanguage: FormLanguage;
    /** De tekst onder elk formulier */
    formOutro?: string | null;
    /** De tekst welke wordt weergegeven bij de PDF download */
    formDownloadInformation?: string | null;
}

/** formFields */
export class FormsGenericFormFormFields implements IFormsGenericFormFormFields {
    /** formFieldContent */
    formFieldContent!: FormsGenericFormFormFieldsFormFieldContent[];

    constructor(data?: IFormsGenericFormFormFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.formFieldContent) {
                this.formFieldContent = [];
                for (let i = 0; i < data.formFieldContent.length; i++) {
                    let item = data.formFieldContent[i];
                    this.formFieldContent[i] = item && !(<any>item).toJSON ? new FormsGenericFormFormFieldsFormFieldContent(item) : <FormsGenericFormFormFieldsFormFieldContent>item;
                }
            }
        }
        if (!data) {
            this.formFieldContent = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formFieldContent"])) {
                this.formFieldContent = [] as any;
                for (let item of _data["formFieldContent"])
                    this.formFieldContent!.push(FormsGenericFormFormFieldsFormFieldContent.fromJS(item));
            }
            else {
                this.formFieldContent = <any>null;
            }
        }
    }

    static fromJS(data: any): FormsGenericFormFormFields {
        data = typeof data === 'object' ? data : {};
        let result = new FormsGenericFormFormFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formFieldContent)) {
            data["formFieldContent"] = [];
            for (let item of this.formFieldContent)
                data["formFieldContent"].push(item.toJSON());
        }
        return data;
    }
}

/** formFields */
export interface IFormsGenericFormFormFields {
    /** formFieldContent */
    formFieldContent: IFormsGenericFormFormFieldsFormFieldContent[];
}

/** formFieldContent */
export class FormsGenericFormFormFieldsFormFieldContent implements IFormsGenericFormFormFieldsFormFieldContent {
    /** inputIdentifier */
    inputIdentifier!: string;
    /** inputLabel */
    inputLabel!: string;
    /** inputAdditionalInformation */
    inputAdditionalInformation?: string | null;

    constructor(data?: IFormsGenericFormFormFieldsFormFieldContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputIdentifier = _data["inputIdentifier"] !== undefined ? _data["inputIdentifier"] : <any>null;
            this.inputLabel = _data["inputLabel"] !== undefined ? _data["inputLabel"] : <any>null;
            this.inputAdditionalInformation = _data["inputAdditionalInformation"] !== undefined ? _data["inputAdditionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): FormsGenericFormFormFieldsFormFieldContent {
        data = typeof data === 'object' ? data : {};
        let result = new FormsGenericFormFormFieldsFormFieldContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputIdentifier"] = this.inputIdentifier !== undefined ? this.inputIdentifier : <any>null;
        data["inputLabel"] = this.inputLabel !== undefined ? this.inputLabel : <any>null;
        data["inputAdditionalInformation"] = this.inputAdditionalInformation !== undefined ? this.inputAdditionalInformation : <any>null;
        return data;
    }
}

/** formFieldContent */
export interface IFormsGenericFormFormFieldsFormFieldContent {
    /** inputIdentifier */
    inputIdentifier: string;
    /** inputLabel */
    inputLabel: string;
    /** inputAdditionalInformation */
    inputAdditionalInformation?: string | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

/** formLanguage <ul><li>nl: Nederlands</li><li>en: English</li></ul> */
export enum FormLanguage {
    En = "en",
    Nl = "nl",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ClientApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isClientApiException = true;

    static isClientApiException(obj: any): obj is ClientApiException {
        return obj.isClientApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ClientApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}